import { FormLabel, InputLista, FormError } from '../../../../components/common'
import { OPERATION_MODE } from '@laramie/ui';
import AccordionIcon from '../AccordionIcon'
import { DefinicionCaducidad } from './components'
import { TRATAMIENTO_PAGOS_TYPE } from '../../../../consts/tratamientoPagosType'

const CriteriosCaducidad = ({ open, toggle, formValues, handleInputProxy, errorOf, params, otherValues, setOtherValues, setPendingChange }) => {
    return <>
        <div className='accordion-header m-top-20'>
            <div className='row'>
                <div className="col-12" onClick={toggle}>
                    <div className='accordion-header-title'>
                        <AccordionIcon {...{open}} />
                        <h3 className={open ? 'active' : ''}>Criterios de caducidad</h3>
                    </div>
                </div>
            </div>
        </div>
        {open &&
            <div className='accordion-body'>
                <div className='row form-basic'>
                    <div className="col-12 col-md-6 col-lg-3">
                        <FormLabel htmlFor="idTipoTratamientoPagos" required>Pagos previos a la caducidad</FormLabel>
                        <InputLista
                            name="idTipoTratamientoPagos"
                            placeholder=""
                            className={`form-control ${errorOf('idTipoTratamientoPagos') ? 'is-invalid' : ''}`}
                            value={formValues.idTipoTratamientoPagos}
                            onChange={handleInputProxy}
                            lista="TipoTratamientoPagos"
                            filter={row => row.id !== TRATAMIENTO_PAGOS_TYPE.APLICACION_DEUDA_ORIGINAL || (formValues.aplicaDeudaAdministrativa && !formValues.aplicaDeudaLegal)}
                            disabled={params.mode === OPERATION_MODE.VIEW}
                        />
                        <FormError message={errorOf('idTipoTratamientoPagos')} />
                    </div>
                </div>
                <div className='row'>
                    <DefinicionCaducidad
                        {...{params}}
                        data={otherValues.planPagosDefinicionCaducidadCuota}
                        setData={data => setOtherValues(prev => ({...prev, planPagosDefinicionCaducidadCuota: data}))}
                        params={params}
                        setPendingChange={setPendingChange}
                    />
                </div>
            </div>
        }
    </>
}

export default CriteriosCaducidad
